module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"browser_title":"Privacy","privacy":"Privacy"},"ja":{"browser_title":"プライバシー声明","privacy":"プライバシー声明"}}')
  delete Component.options._Ctor
}
